document.addEventListener('DOMContentLoaded', () => {
  const navToggle = document.querySelector('[data-aa-nav-toggle]');
  const navPanel = document.querySelector('[data-aa-nav-panel]');

  if (navToggle && navPanel) {
    navToggle.addEventListener('click', () => {
      const expanded = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!expanded));
      navPanel.classList.toggle('is-open', !expanded);
    });
  }

  document.querySelectorAll('[data-aa-featured]').forEach((section) => {
    const variantButtons = section.querySelectorAll('[data-aa-variant-button]');
    const variantSelect = section.querySelector('[data-aa-variant-select]');
    const priceTarget = section.querySelector('[data-aa-featured-price]');

    variantButtons.forEach((button) => {
      button.addEventListener('click', () => {
        variantButtons.forEach((pill) => pill.classList.remove('is-active'));
        button.classList.add('is-active');

        if (variantSelect) {
          variantSelect.value = button.dataset.variantId || '';
        }

        if (priceTarget && button.dataset.variantPrice) {
          priceTarget.textContent = button.dataset.variantPrice;
        }
      });
    });
  });

  const revealTargets = document.querySelectorAll('[data-aa-reveal]');
  if (revealTargets.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );

    revealTargets.forEach((element) => observer.observe(element));
  }

  const desktopCarouselQuery = window.matchMedia('(min-width: 990px)');

  document.querySelectorAll('[data-aa-product-carousel]').forEach((viewport) => {
    const track = viewport.querySelector('.aa-product-grid');
    const section = viewport.closest('.aa-section');
    const controls = section?.querySelector('[data-aa-carousel-controls]');
    const prevButton = section?.querySelector('[data-aa-carousel-prev]');
    const nextButton = section?.querySelector('[data-aa-carousel-next]');

    if (!track || !section || !controls || !prevButton || !nextButton) {
      return;
    }

    const dragState = {
      active: false,
      moved: false,
      pointerId: null,
      startX: 0,
      startScrollLeft: 0,
      totalDelta: 0
    };

    const maxPull = 88;
    let releasePullFrame = null;
    let settleAnimationFrame = null;
    let suppressClick = false;

    const syncViewportWidth = () => {
      section.style.setProperty('--aa-editorial-viewport-width', `${viewport.clientWidth}px`);
    };

    const setPull = (value) => {
      section.style.setProperty('--aa-editorial-track-pull', `${value}px`);
    };

    const resetPull = () => {
      if (releasePullFrame) {
        cancelAnimationFrame(releasePullFrame);
      }

      releasePullFrame = requestAnimationFrame(() => {
        setPull(0);
      });
    };

    const getGap = () => {
      const styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap || '0');
    };

    const getStep = () => {
      const firstCard = track.querySelector('.aa-product-card');

      if (!firstCard) {
        return viewport.clientWidth;
      }

      return firstCard.getBoundingClientRect().width + getGap();
    };

    const getMaxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);

    const stopSettleAnimation = () => {
      if (settleAnimationFrame) {
        cancelAnimationFrame(settleAnimationFrame);
        settleAnimationFrame = null;
      }
    };

    const animateScrollTo = (targetLeft, duration = 380) => {
      stopSettleAnimation();

      const startLeft = viewport.scrollLeft;
      const delta = targetLeft - startLeft;

      if (Math.abs(delta) < 1) {
        viewport.scrollLeft = targetLeft;
        updateControls();
        return;
      }

      const startTime = performance.now();
      const easeOutQuint = (value) => 1 - ((1 - value) ** 5);

      const tick = (now) => {
        const progress = Math.min(1, (now - startTime) / duration);
        const eased = easeOutQuint(progress);

        viewport.scrollLeft = startLeft + (delta * eased);
        updateControls();

        if (progress < 1) {
          settleAnimationFrame = requestAnimationFrame(tick);
        } else {
          settleAnimationFrame = null;
          viewport.scrollLeft = targetLeft;
          updateControls();
        }
      };

      settleAnimationFrame = requestAnimationFrame(tick);
    };

    const updateControls = () => {
      syncViewportWidth();

      const activeDesktopCarousel = desktopCarouselQuery.matches;
      const maxScroll = getMaxScroll();
      const hasScrollableOverflow = activeDesktopCarousel && maxScroll > 6;

      controls.hidden = !hasScrollableOverflow;
      prevButton.disabled = !hasScrollableOverflow || viewport.scrollLeft <= 2;
      nextButton.disabled = !hasScrollableOverflow || viewport.scrollLeft >= maxScroll - 2;

      if (!activeDesktopCarousel) {
        viewport.classList.remove('is-dragging');
        resetPull();
      }
    };

    const scrollByStep = (direction) => {
      const maxScroll = getMaxScroll();
      const nextLeft = Math.max(0, Math.min(maxScroll, viewport.scrollLeft + (getStep() * direction)));

      animateScrollTo(nextLeft);
    };

    const settleToCard = (dragDelta = 0) => {
      if (!desktopCarouselQuery.matches) {
        return;
      }

      const step = getStep();
      const maxScroll = getMaxScroll();

      if (!step || maxScroll <= 0) {
        return;
      }

      const originIndex = Math.round(dragState.startScrollLeft / step);
      const currentIndex = Math.round(viewport.scrollLeft / step);
      const threshold = step * 0.14;
      let targetIndex = currentIndex;

      if (Math.abs(dragDelta) > threshold) {
        const direction = dragDelta < 0 ? 1 : -1;
        const skipCount = Math.max(1, Math.round(Math.abs(dragDelta) / step));
        targetIndex = originIndex + (direction * skipCount);
      }

      const nextLeft = Math.max(0, Math.min(maxScroll, targetIndex * step));

      animateScrollTo(nextLeft, 420);
    };

    const releaseDrag = () => {
      if (!dragState.active) {
        return;
      }

      dragState.active = false;
      viewport.classList.remove('is-dragging');

      if (dragState.pointerId !== null) {
        try {
          viewport.releasePointerCapture(dragState.pointerId);
        } catch (_error) {
          // Ignore pointer capture release errors from already-released pointers.
        }
      }

      dragState.pointerId = null;
      suppressClick = dragState.moved;
      resetPull();
      if (dragState.moved) {
        settleToCard(dragState.totalDelta);
      }
      updateControls();
    };

    prevButton.addEventListener('click', () => scrollByStep(-1));
    nextButton.addEventListener('click', () => scrollByStep(1));

    viewport.addEventListener('pointerdown', (event) => {
      if (!desktopCarouselQuery.matches || getMaxScroll() <= 6) {
        return;
      }

      if (event.pointerType === 'mouse' && event.button !== 0) {
        return;
      }

      dragState.active = true;
      dragState.moved = false;
      dragState.pointerId = event.pointerId;
      dragState.startX = event.clientX;
      dragState.startScrollLeft = viewport.scrollLeft;
      dragState.totalDelta = 0;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
      stopSettleAnimation();

      if (releasePullFrame) {
        cancelAnimationFrame(releasePullFrame);
      }
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!dragState.active || dragState.pointerId !== event.pointerId) {
        return;
      }

      const delta = event.clientX - dragState.startX;
      const nextScrollLeft = dragState.startScrollLeft - delta;
      const maxScroll = getMaxScroll();
      dragState.totalDelta = delta;

      if (Math.abs(delta) > 6) {
        dragState.moved = true;
      }

      if (nextScrollLeft < 0) {
        viewport.scrollLeft = 0;
        setPull(Math.max(nextScrollLeft * 0.34, -maxPull));
        return;
      }

      if (nextScrollLeft > maxScroll) {
        viewport.scrollLeft = maxScroll;
        setPull(Math.max(-(nextScrollLeft - maxScroll) * 0.34, -maxPull));
        return;
      }

      viewport.scrollLeft = nextScrollLeft;
      setPull(0);
      updateControls();
    });

    viewport.addEventListener('pointerup', releaseDrag);
    viewport.addEventListener('pointercancel', releaseDrag);
    viewport.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') {
        return;
      }

      releaseDrag();
    });

    viewport.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      },
      true
    );

    viewport.addEventListener('dragstart', (event) => {
      event.preventDefault();
    });

    viewport.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);

    if (typeof desktopCarouselQuery.addEventListener === 'function') {
      desktopCarouselQuery.addEventListener('change', updateControls);
    } else if (typeof desktopCarouselQuery.addListener === 'function') {
      desktopCarouselQuery.addListener(updateControls);
    }

    updateControls();
  });
});
